import {
  EmailVerification,
  GoogleLoginScreen,
  GoogleRedirectScreen,
  GoogleSignupScreen,
  SignupScreen,
} from "../screens";
import InvalidTokenScreen from "../screens/DefaultScreens/InvalidTokenScreen";
import MicrosoftRedirectScreen from "../screens/DefaultScreens/MicrosoftRedirectScreen";
import WaitingScreen from "../screens/DefaultScreens/WaitingScreen";
import ConnectInboxGoogleRedirectScreen from "../screens/SignupScreen/ConnectInboxGoogleRedirectScreen";
import ConnectInboxMicrosoftRedirectScreen from "../screens/SignupScreen/ConnectInboxMicrosoftRedirectScreen";
import ConnectInboxScreen from "../screens/SignupScreen/ConnectInboxScreen";
import ConnectInboxZohoRedirectScreen from "../screens/SignupScreen/ConnectInboxZohoRedirectScreen";
import MicrosoftLoginScreen from "../screens/SignupScreen/MicrosoftLoginScreen";

// ─── New Onboarding v2 screens ───────────────────────────────────────────────
import PlanScreen from "../screens/SignupScreen/PlanScreen";
import ResumeScreen from "../screens/SignupScreen/ResumeScreen";
import ResetDraftPasswordScreen from "../screens/SignupScreen/ResetDraftPasswordScreen";
import SubdomainScreen from "../screens/SignupScreen/SubdomainScreen";
import VerifyEmailPendingScreen from "../screens/SignupScreen/VerifyEmailPendingScreen";
import WelcomeScreen from "../screens/SignupScreen/WelcomeScreen";
import PaymentSuccessScreen from "../screens/SignupScreen/PaymentSuccessScreen";
import PaymentCancelScreen from "../screens/SignupScreen/PaymentCancelScreen";
// ─────────────────────────────────────────────────────────────────────────────

import {
  CONNECT_INBOX_PATH,
  CONNECT_INBOX_GOOGLE_REDIRECT_PATH,
  EMAIL_VERIFICATION_PATH,
  GOOGLE_LOGIN_PATH,
  GOOGLE_REDIRECT_PATH,
  GOOGLE_SIGNUP_PATH,
  INVALID_TOKEN_PATH,
  MICROSOFT_LOGIN_PATH,
  MICROSOFT_REDIRECT_PATH,
  SIGNUP_PATH,
  SIGNUP_TRIAL_PATH,
  SIGNUP_RESUME_PATH,
  RESET_DRAFT_PASSWORD_PATH,
  WAITING_PAGE_PATH,
  CONNECT_INBOX_MICROSOFT_REDIRECT_PATH,
  CONNECT_INBOX_ZOHO_REDIRECT_PATH,
  // New v2 route constants
  PLAN_PATH,
  CREATE_WORKSPACE_PATH,
  VERIFY_EMAIL_PENDING_PATH,
  WELCOME_PATH,
  PAYMENT_SUCCESS_PATH,
  PAYMENT_CANCEL_PATH,
} from "../utils/constants/routes";

export const authRoutes = [
  {
    path: SIGNUP_PATH,
    component: SignupScreen,
  },
  {
    path: SIGNUP_TRIAL_PATH,
    component: SignupScreen,
  },
  {
    path: SIGNUP_RESUME_PATH,
    component: ResumeScreen,
  },
  {
    path: RESET_DRAFT_PASSWORD_PATH,
    component: ResetDraftPasswordScreen,
  },
  {
    path: GOOGLE_SIGNUP_PATH,
    component: GoogleSignupScreen,
  },
  {
    path: CONNECT_INBOX_PATH,
    component: ConnectInboxScreen,
  },
  {
    path: CONNECT_INBOX_GOOGLE_REDIRECT_PATH,
    component: ConnectInboxGoogleRedirectScreen,
  },
  {
    path: CONNECT_INBOX_MICROSOFT_REDIRECT_PATH,
    component: ConnectInboxMicrosoftRedirectScreen,
  },
  {
    path: CONNECT_INBOX_ZOHO_REDIRECT_PATH,
    component: ConnectInboxZohoRedirectScreen,
  },
  {
    path: EMAIL_VERIFICATION_PATH,
    component: EmailVerification,
  },
  {
    path: INVALID_TOKEN_PATH,
    component: InvalidTokenScreen,
  },

  {
    path: GOOGLE_REDIRECT_PATH,
    component: GoogleRedirectScreen,
  },
  {
    path: GOOGLE_LOGIN_PATH,
    component: GoogleLoginScreen,
  },
  // Microsoft Routes
  {
    path: MICROSOFT_LOGIN_PATH,
    component: MicrosoftLoginScreen,
  },
  {
    path: MICROSOFT_REDIRECT_PATH,
    component: MicrosoftRedirectScreen,
  },

  // Microsoft Routes
  {
    path: WAITING_PAGE_PATH,
    component: WaitingScreen,
  },

  // ─── New Onboarding v2 Routes ──────────────────────────────────────────────
  {
    path: PLAN_PATH,
    component: PlanScreen,
  },
  {
    path: CREATE_WORKSPACE_PATH,
    component: SubdomainScreen,
  },
  {
    path: VERIFY_EMAIL_PENDING_PATH,
    component: VerifyEmailPendingScreen,
  },
  {
    path: WELCOME_PATH,
    component: WelcomeScreen,
  },
  {
    path: PAYMENT_SUCCESS_PATH,
    component: PaymentSuccessScreen,
  },
  {
    path: PAYMENT_CANCEL_PATH,
    component: PaymentCancelScreen,
  },
  // ─────────────────────────────────────────────────────────────────────────────
]
